import { DomainEvent, OrderEvent } from "../types/types";

export const getTitle = (title: any) => {
  return title?.translations?.en || "";
};

export const formatDate = (date: string) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return formatter.format(new Date(date));
};

export function isOrderEvent(event: DomainEvent): event is OrderEvent {
  return event.eventName.startsWith("order.");
}
